document.addEventListener('DOMContentLoaded', () => {
    const highlights = document.querySelectorAll('span.highlight');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('highlighted');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.4
    });

    highlights.forEach(span => observer.observe(span));
});
